import { computed, Inject, Injectable, Optional, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { UserAccount, UserPreferences } from '@iot-platform/models/common';
import { EMPTY } from 'rxjs';
import { FILTER_ENGINE_SETTINGS } from '../filter-engine-settings.providers';
import { FilterEngineOptions, FilterEngineSettings } from '../models';
import { AbstractUserPreferencesFavoriteFilterEngineService } from './abstract-user-preferences-favorite-filter-engine.service';

/* eslint-disable @angular-eslint/prefer-inject */
@Injectable({ providedIn: 'root' })
export class FilterEngineSettingsService {
  account: Signal<UserAccount> = toSignal(this.userPreferencesService?.getAccount$().pipe(takeUntilDestroyed()) ?? EMPTY);
  userPreferences: Signal<UserPreferences> = toSignal(this.userPreferencesService?.getUserPreferences$().pipe(takeUntilDestroyed()) ?? EMPTY);
  options: Signal<FilterEngineOptions> = computed(() => {
    this.account();
    this.userPreferences();
    return this.filterEngineSettings?.options;
  });

  constructor(
    @Optional() @Inject(FILTER_ENGINE_SETTINGS) private readonly filterEngineSettings: FilterEngineSettings,
    @Optional() private readonly userPreferencesService: AbstractUserPreferencesFavoriteFilterEngineService
  ) {}

  saveUserPreferences(preferences: UserPreferences): void {
    return this.userPreferencesService?.saveUserPreferences(preferences);
  }
}
